import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { useMenuContext } from '../Menu.Context/index.es.js';

/**
 * Hook for creating consistent menu arrow animations and styling.
 * @param options - Customization options for the arrow.
 * @returns Icon component.
 * @example
 * ```tsx
 * const MySimpleTrigger = () => {
 *   const arrowIcon = useMenuTriggerArrow({
 *     colorClass: 'text-interactive',
 *     iconName: 'ChevronDownSolid',
 *     size: 16
 *   })
 *
 *   return (
 *     <Chip variant="default/info">
 *       Filter Options
 *       {arrowIcon}
 *     </Chip>
 *   )
 * }
 * ```
 */ function useMenuTriggerArrow({ colorClass = 'text-icon-neutral', className, size = 20, iconName = 'ChevronDownSolid' }) {
    const [{ open }] = useMenuContext();
    const arrowClassName = useMemo(()=>classNames('cb-menu-trigger-arrow', colorClass, {
            open
        }, className), [
        open,
        colorClass,
        className
    ]);
    return jsx(Icon, {
        className: arrowClassName,
        name: iconName,
        size: size
    });
}

export { useMenuTriggerArrow };
//# sourceMappingURL=useMenuTriggerArrow.es.js.map
